import React, { useState } from "react";
import { Link } from "gatsby";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import settings from "../../data/settings.yaml";
import { ArrowRight } from "react-bootstrap-icons";
import MCGLogo from "../../media/logos/mcg-logo-color.svg";

export function validateSettings(settings) {
  if (!settings?.menu?.items) {
    console.warn(
      "No menu items were found. Please specify a `mainMenu` object in src/data/settings.yaml. It should be a list of menu items, each having a `path` and `label` property."
    );
    return false;
  } else {
    return true;
  }
}

function DropdownMenu({ items, label = "More" } = {}) {
  return (
    <NavDropdown
      title={label}
      className="d-none d-md-block d-xl-none"
      align="end"
    >
      {items.map((item) => {
        return (
          <NavDropdown.Item
            as={Link}
            to={item.path}
            key={`dropdown-${item.path}`}
            activeClassName="active"
            partiallyActive={true}
          >
            {item.label}
          </NavDropdown.Item>
        );
      })}
    </NavDropdown>
  );
}

function Menu({ pageTitle, currentPath, handleShowSidebar }) {
  const [expanded, setExpanded] = useState(false);

  const valid = validateSettings(settings);
  const menuItems = valid ? settings.menu?.items.slice() : undefined;
  const dropdownItems = [
    ...menuItems.filter((item) => item.inDropdownOnSmallScreens),
  ];

  return (
    <Navbar
      expand="md"
      className={`main-menu sticky-top align-items-start py-0 py-md-2 ${
        expanded ? "expanded " : "collapsed"
      }`}
      variant={expanded ? "dark" : "light"}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <button
          aria-controls="sidebar"
          type="button"
          aria-label="Toggle table of contents"
          className="navbar-toggler d-block d-lg-none border-0 text-primary me-3"
          onClick={handleShowSidebar}
        >
          <ArrowRight />
        </button>
        <Navbar.Brand
          as={Link}
          to="/"
          className="d-none d-lg-block col-lg-3 me-0 nav-link"
        >
          <img
            src={MCGLogo}
            alt="Music Cognition Group"
            height="20"
            style={{ paddingRight: ".5em", marginTop: "-.2em" }}
          />
          {settings.site.title}
        </Navbar.Brand>
        <div
          className="d-block d-md-none text-truncate"
          style={{ maxWidth: "70%" }}
        >
          {currentPath === "/" ? null : (
            <>
              <Link to="/" className="">
                {settings.site.shortTitle}
              </Link>
              <span className="mx-2">→</span>
            </>
          )}
          <span className="text-truncate">{pageTitle}</span>
        </div>

        <Navbar.Toggle
          className={`d-md-none hamburger hamburger--collapse ${
            expanded ? "is-active" : null
          }`}
          aria-controls="navbar"
          type="button"
        >
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </Navbar.Toggle>

        <Navbar.Collapse
          id="navbar"
          style={{ maxHeight: "80vh" }}
          className={
            expanded ? "overflow-auto hide-scrollbar text-center" : null
          }
        >
          {!menuItems ? (
            <div className="alert alert-danger">No menu items were found</div>
          ) : (
            <Nav className="me-auto ">
              <Nav.Link
                as={Link}
                to="/"
                key="/"
                className="d-block d-lg-none"
                activeClassName="active text-primary"
              >
                MCG
              </Nav.Link>

              {menuItems.map((item) => {
                return (
                  <Nav.Link
                    as={Link}
                    to={`${item.path}`}
                    key={`main-item-${item.path}`}
                    className={
                      item.inDropdownOnSmallScreens && "d-md-none d-xl-block"
                    }
                    activeClassName="active text-primary"
                    partiallyActive={true}
                  >
                    {item.label}
                  </Nav.Link>
                );
              })}

              <DropdownMenu
                items={dropdownItems}
                label={settings.menu.dropdownLabel}
              />
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;
